import React, { useState, useEffect } from "react";
import { Layout, Menu, Avatar, Space, Dropdown, Typography, Modal, Spin, Drawer, Grid, Button } from 'antd';
import { DownOutlined, DashboardOutlined, UsergroupAddOutlined, LogoutOutlined, UserOutlined, ExclamationCircleOutlined, WalletOutlined, FileTextOutlined, BarChartOutlined, SearchOutlined, MenuOutlined, CloseOutlined, BellOutlined } from '@ant-design/icons';
import { withRouter, matchPath, useLocation } from 'react-router-dom';
import { routes } from '../../../routes/Routes';
import "../../../assets/dist/ConsumerProject/Administrator/Sidebar.css";
import _consumerService from "../../../modules/consumerService";
import _AdministratorService from "../../../modules/AdministratorService";
import _capitalProviderService from "../../../modules/capitalProviderService";
const { Header, Footer, Sider, Content } = Layout;
const { confirm } = Modal;

const SidebarLayoutConsumer = ({ children, location, history }) => {
    const [loading, setLoading] = useState(false);
    // const isLoanOfficer = JSON.parse(localStorage.getItem("IsLoanofficerFlag") || "false");
    const isAdministratorLogin = JSON.parse(localStorage.getItem("IsAdministratorFlag") || "false");
    // const IsFirmAdmin = JSON.parse(localStorage.getItem("IsFirmAdminFlag") || "false");
    const isConsumerLogin = JSON.parse(localStorage.getItem("IsConsumerFlag") || "false");
    const isCapitalProviderLogin = JSON.parse(localStorage.getItem("IsCapitalProviderFlag") || "false");
    const consumerId = localStorage.getItem("ConsumerUserId");
    const administratorId = localStorage.getItem("administratorUserId");
    const capitalProviderUserId = localStorage.getItem("capitalProviderUserId");
    const [consumerName, setConsumerName] = useState("");
    const [administrator, setAdministrator] = useState("");
    const [capitalProvider, setcapitalProvider] = useState("");

    const [drawerVisible, setDrawerVisible] = useState(false);
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();


    // const currentLocation = useLocation();

    useEffect(() => {
        if (isConsumerLogin) {
            GetConsumerInformationByConsumerId();
        }

        if (isAdministratorLogin) {
            GetBankerInformationByBankerId();
        }

        if (isCapitalProviderLogin) {
            getLoanOfficerInformationByLoanOfficerId();
        }
    }, [isConsumerLogin, isAdministratorLogin, isCapitalProviderLogin]);

    const GetConsumerInformationByConsumerId = async () => {
        try {
            setLoading(true);
            const res = await _consumerService.getConsumerInformationByConsumerId(consumerId);

            if (res?.data) {
                // Create full name
                const fullName = `${res.data.App_Det_FirstName ?? ""} ${res.data.App_Det_MiddleInitial ?? ""
                    } ${res.data.App_Det_LastName ?? ""}`.trim();

                setConsumerName(fullName);
            }
        } catch (error) {
            console.error("Error fetching consumer information:", error);
        } finally {
            setLoading(false);
        }
    };

    const GetBankerInformationByBankerId = async () => {
        try {
            setLoading(true);
            const res = await _AdministratorService.getBankerInformationByBankerId(administratorId);

            if (res?.data?.Obj) {
                const { FirstName, MiddleInitial, LastName } = res.data.Obj;

                // Build full name without extra spaces
                const fullName = [FirstName, MiddleInitial, LastName]
                    .filter(Boolean) // removes null, undefined, empty strings
                    .join(" ");

                setAdministrator(fullName);
            }
        } catch (error) {
            console.error("Error fetching administrator information:", error);
        } finally {
            setLoading(false);
        }
    };

    const getLoanOfficerInformationByLoanOfficerId = async () => {
        try {
            setLoading(true);
            const res = await _capitalProviderService.getLoanOfficerInformationByLoanOfficerId(capitalProviderUserId);

            if (res?.data?.Obj) {
                const { FirstName, MiddleInitial, LastName } = res.data.Obj;

                // Build full name without extra spaces
                const fullName = [FirstName, MiddleInitial, LastName]
                    .filter(Boolean) // removes null, undefined, empty strings
                    .join(" ");

                setcapitalProvider(fullName);
            }
        } catch (error) {
            console.error("Error fetching capital Provider information:", error);
        } finally {
            setLoading(false);
        }
    };

    // const menuItems = isLoanOfficer
    //   ? [
    //     { key: '/loanOfficerDashboard', icon: <DashboardOutlined />, label: 'Dashboard' },
    //     { key: '/loanApplicationsForLoanOfficer', icon: <FileTextOutlined />, label: 'Loan Applications' },
    //   ]
    //   : [
    //     { key: '/banker-dashboard', icon: <DashboardOutlined />, label: 'Dashboard' },
    //     { key: '/loan-application', icon: <FileTextOutlined />, label: 'Loan Applications' },
    //     // { key: '/revision-request', icon: <ReloadOutlined />, label: 'Revisit Applications' },
    //     { key: '/sponsors', icon: <UsergroupAddOutlined />, label: 'Loan Program Dashboard' }
    //   ];

    let menuItems = [];

    // if (isLoanOfficer) {
    //   menuItems = [
    //     {
    //       key: routes.loanOfficerDashboard.path,
    //       icon: <DashboardOutlined />,
    //       label: 'Loan Application Dashboard',
    //       matchPaths: [routes.loanOfficerDashboard.path],
    //     },
    //     {
    //       key: routes.loanApplicationsForLoanOfficer.path,
    //       icon: <FileTextOutlined />,
    //       label: 'Review Loan Applications',
    //       matchPaths: [routes.loanApplicationsForLoanOfficer.path, routes.loanApplicationDetails.path],
    //     },
    //     {
    //       key: routes.dataInsights.path,
    //       icon: <BarChartOutlined />,
    //       label: 'Data Insights',
    //       matchPaths: [routes.dataInsights.path],
    //     },
    //   ]
    // } 

    if (isConsumerLogin) {
        menuItems = [
            {
                key: routes.consumerDashboard.path,
                icon: <DashboardOutlined />,
                label: 'Dashboard',
                matchPaths: [
                    routes.consumerDashboard.path,
                    routes.newLiquidityApplication.path,
                    routes.consumerUploadDocumentsPreview.path,
                    routes.documentsUpload.path,
                    routes.consumerDetailsDashboard.path,
                    routes.incomeSourcesForConsumer.path,
                    routes.expensesForConsumer.path,
                    routes.balanceSheetAssetsForConsumer.path,
                    routes.balanceSheetTotalAssetsForConsumer.path,
                    routes.balanceSheetTotalLiabilitiesForConsumer.path,
                    routes.questionnaireForConsumer.path
                ],
            },
            {
                key: routes.consumerMarketPlace.path,
                icon: <WalletOutlined />,
                label: 'Marketplace',
                matchPaths: [routes.consumerMarketPlace.path],
            },
            {
                key: routes.consumerReports.path,
                icon: <FileTextOutlined />,
                label: 'Reports',
                matchPaths: [routes.consumerReports.path],
            },
            {
                key: routes.consumerInsightsReports.path,
                icon: <BarChartOutlined />,
                label: 'Data Insights',
                matchPaths: [routes.consumerInsightsReports.path],
            },
        ]
    }
    // if (IsFirmAdmin) {
    //   menuItems = [
    //     {
    //       key: routes.firmadmindashboard.path,
    //       icon: <DashboardOutlined />,
    //       label: 'Dashboard',
    //       matchPaths: [routes.firmadmindashboard.path, routes.firmadminsponsersdetails.path],
    //     },
    //     {
    //       key: routes.liveAccountBalances.path,
    //       icon: <WalletOutlined />,
    //       label: 'Live Account Balances',
    //       matchPaths: [routes.liveAccountBalances.path],
    //     },
    //     {
    //       key: routes.advancesAndRepayments.path,
    //       icon: <RetweetOutlined />,
    //       label: 'Advances & Repayments',
    //       matchPaths: [routes.advancesAndRepayments.path],
    //     },
    //     {
    //       key: routes.dataInsights.path,
    //       icon: <BarChartOutlined />,
    //       label: 'Data Insights',
    //       matchPaths: [routes.dataInsights.path],
    //     },
    //   ]
    // }
    else if (isAdministratorLogin) {
        menuItems = [
            {
                key: routes.administratorDashboard.path,
                icon: <DashboardOutlined />,
                label: 'Dashboard',
                matchPaths: [routes.administratorDashboard.path, routes.loanApplicationDetailsForAdministrator.path],
            },
            // {
            //   key: routes.loanApplicationsForAdministrator.path,
            //   icon: <FileTextOutlined />,
            //   label: 'Review Loan Applications',
            //   matchPaths: [routes.loanApplicationsForAdministrator.path, routes.loanApplicationDetailsForAdministrator.path],
            // },
            {
                key: routes.sponsorsCapitalProvider.path,
                icon: <UsergroupAddOutlined />,
                label: 'Manage Capital Providers',
                matchPaths: [routes.sponsorsCapitalProvider.path, routes.addEditSponsersForAdministrator.path],
            },
            {
                key: routes.administratorReports.path,
                icon: <FileTextOutlined />,
                label: 'Reports',
                matchPaths: [routes.administratorReports.path],
            },
            {
                key: routes.dataInsightsForAdministrator.path,
                icon: <BarChartOutlined />,
                label: 'Data Insights',
                matchPaths: [routes.dataInsightsForAdministrator.path],
            },
        ];
    } else if (isCapitalProviderLogin) {
        menuItems = [
            {
                key: routes.capitalProviderDashboard.path,
                icon: <DashboardOutlined />,
                label: 'Dashboard',
                matchPaths: [routes.capitalProviderDashboard.path, routes.loanApplicationDetailsForAdministrator.path],
            },
            // {
            //   key: routes.loanApplicationsForCapitalProvider.path,
            //   icon: <FileTextOutlined />,
            //   label: 'Review Loan Applications',
            //   matchPaths: [routes.loanApplicationsForCapitalProvider.path, routes.loanApplicationDetailsForAdministrator.path],
            // },
            {
                key: routes.capitalProviderReports.path,
                icon: <FileTextOutlined />,
                label: 'Reports',
                matchPaths: [routes.capitalProviderReports.path],
            },
            {
                key: routes.dataInsightsForCapitalProvider.path,
                icon: <BarChartOutlined />,
                label: 'Data Insights',
                matchPaths: [routes.dataInsightsForCapitalProvider.path],
            },
        ]
    }
    // const menuItems = isLoanOfficer
    //   ? [
    //     {
    //       key: routes.loanOfficerDashboard.path,
    //       icon: <DashboardOutlined />,
    //       label: 'Loan Application Dashboard',
    //       matchPaths: [routes.loanOfficerDashboard.path],
    //     },
    //     {
    //       key: routes.loanApplicationsForLoanOfficer.path,
    //       icon: <FileTextOutlined />,
    //       label: 'Review Loan Applications',
    //       matchPaths: [routes.loanApplicationsForLoanOfficer.path, routes.loanApplicationDetails.path],
    //     },
    //   ]
    //   : [
    //     {
    //       key: routes.bankerdashboard.path,
    //       icon: <DashboardOutlined />,
    //       label: 'Loan Application Dashboard',
    //       matchPaths: [routes.bankerdashboard.path],
    //     },
    //     {
    //       key: routes.loanapplication.path,
    //       icon: <FileTextOutlined />,
    //       label: 'Review Loan Applications',
    //       matchPaths: [routes.loanapplication.path, routes.loanApplicationDetails.path],
    //     },
    //     {
    //       key: routes.sponsors.path,
    //       icon: <UsergroupAddOutlined />,
    //       label: 'Loan Program Dashboard',
    //       matchPaths: [routes.sponsors.path, routes.addEditSponsers.path],
    //     },
    //     {
    //       key: routes.liveAccountBalances.path,
    //       icon: <WalletOutlined />,
    //       label: 'Live Account Balances',
    //       matchPaths: [routes.liveAccountBalances.path],
    //     },
    //     {
    //       key: routes.advancesAndRepayments.path,
    //       icon: <RetweetOutlined />,
    //       label: 'Advances & Repayments',
    //       matchPaths: [routes.advancesAndRepayments.path],
    //     },
    //     {
    //       key: routes.dataInsights.path,
    //       icon: <BarChartOutlined />,
    //       label: 'Data Insights',
    //       matchPaths: [routes.dataInsights.path],
    //     },
    //   ];



    const handleMenuClick = ({ key }) => {
        if (key !== location.pathname) {
            history.push(key);
        }
    };

    // const showLogoutConfirm = () => {
    //     confirm({
    //         title: 'Are you sure you want to logout?',
    //         icon: <ExclamationCircleOutlined />,
    //         okText: "Yes",
    //         cancelText: "No",
    //         okType: "primary",
    //         onOk: handleLogout,
    //     });
    // };

   const showLogoutConfirm = () => {
        confirm({
            title: "Are you sure you want to logout?",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            okType: "primary",   // ✅ YES = primary
            centered: true,
            className: "logout-confirm-modal",
            onOk: handleLogout,
        });
    };


    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        if (isAdministratorLogin == true) {
            history.push(routes.administratorLogin.path);
        } else if (isConsumerLogin == true) {
            history.push(routes.registeredEmail.path);
        } else if (isCapitalProviderLogin == true) {
            history.push(routes.capitalProviderLogin.path);
        }
    };

    const handleAvatarClick = () => {
        if (isConsumerLogin == true) {
            history.push({
                pathname: routes.consumerProfile.path,
                state: {
                    isFromDashboard: true
                }
            });
        } else if (isAdministratorLogin == true) {
            history.push({
                pathname: routes.administratorProfile.path,
                state: {
                    isFromDashboard: true
                }
            });
        } else if (isCapitalProviderLogin == true) {
            history.push({
                pathname: routes.capitalProviderProfile.path,
                state: {
                    isFromDashboard: true
                }
            });
        }
    };

    const userMenu = (
        <Menu>
            <Menu.Item key="logout" icon={<LogoutOutlined style={{ transform: 'rotate(-90deg)' }} />} onClick={showLogoutConfirm}>
                Logout
            </Menu.Item>
        </Menu>
    );

    // const profileMenu = (
    //   <Menu>
    //     <Menu.Item key="My Profile" icon={<UserOutlined />} onClick={handleAvatarClick} >
    //       My Profile
    //     </Menu.Item>
    //   </Menu>
    // );

    const profileMenu = (
        <Menu>
            <Menu.Item
                key="profile"
                icon={<UserOutlined />}
                onClick={handleAvatarClick}
            >
                {/* {isConsumerLogin ? consumerName || "Consumer" : "My Profile"} */}

                {isConsumerLogin
                    ? consumerName
                    : isAdministratorLogin
                        ? administrator
                        : isCapitalProviderLogin
                            ? capitalProvider
                            : " "}
            </Menu.Item>
        </Menu>
    );

    const combinedMenu = (
        <Menu className="user-dropdown-menu-logout">
            {/* Profile */}
            <Menu.Item
                key="profile"
                icon={<UserOutlined />}
                onClick={handleAvatarClick}

            >
                {isConsumerLogin
                    ? consumerName
                    : isAdministratorLogin
                        ? administrator
                        : isCapitalProviderLogin
                            ? capitalProvider
                            : ""}
            </Menu.Item>

            <Menu.Divider />

            {/* Logout */}
            <Menu.Item
                key="logout"
                icon={<LogoutOutlined style={{ transform: 'rotate(-90deg)' }} />}
                onClick={showLogoutConfirm}
            >
                Logout
            </Menu.Item>
        </Menu>
    );


    const getSelectedKey = () => {
        const match = menuItems && menuItems.find(item =>
            item.matchPaths.some(p =>
                !!matchPath(location.pathname, { path: p, exact: false, strict: false })
            )
        );
        return match ? match.key : '';
    };

    // const switchToApplicant = async () => {
    //   let reqObj = {
    //     Email: localStorage.getItem("loginEmail"),
    //     Password: localStorage.getItem("IsKey"),
    //     IsFirmAdmin: false,
    //   }
    //   setLoading(true);
    //   try {
    //     const res = await _consumerService.userLogin(reqObj);
    //     if (res.data.IsSuccess) {
    //       localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
    //       localStorage.setItem("userRole", res?.data?.Obj?.Role);
    //       localStorage.setItem("IsFirmAdminFlag", res?.data?.Obj?.IsFirmAdmin);
    //       localStorage.setItem("SponserIdForFirmLogin", res?.data?.Obj?.SponserId);
    //       localStorage.setItem("ApplicationEmailId", res?.data?.Obj?.Email);
    //       localStorage.setItem("loginEmail", reqObj.Email);
    //       localStorage.setItem("IsKey", reqObj.Password);
    //       localStorage.setItem("IsSwitchFirmAdmin", JSON.stringify(false));
    //       history.push({
    //         pathname: routes.myApplications.path,
    //         state: { "email": reqObj.Email }
    //       });
    //       setLoading(false);
    //     } else {
    //       message.error(res.data.Message || COMMON_ERROR_MSG);
    //       setLoading(false);
    //     }
    //   } catch (err) {
    //     console.log(err);
    //     setLoading(false);
    //   }
    // };

    const sidebarFunction = () => {
        return
        // <Sider
        //     width={260}
        //     className="themeColor"
        //     style={{
        //         backgroundColor: '#0a2a52',
        //         position: 'fixed',
        //         top: 0,
        //         bottom: 0,
        //         left: 0,
        //         zIndex: 100,
        //         display: 'flex',
        //         flexDirection: 'column',
        //         justifyContent: 'space-between',
        //     }}
        // >
        //     <div>
        //         <div
        //             style={{
        //                 height: 64,
        //                 display: "flex",
        //                 alignItems: "center",
        //                 justifyContent: "space-between",
        //                 padding: "0 16px",
        //                 background: "#0a2a52",
        //                 //borderBottom: "1px solid rgba(255,255,255,0.1)"
        //             }}
        //         >
        //             <img src="/SiteLogo11.svg" alt="Logo" height={30} />
        //             {drawerVisible || !screens.md
        //                 ?
        //                 <Button
        //                     type="text"
        //                     icon={<MenuOutlined />}
        //                     onClick={() => setDrawerVisible(false)}
        //                     style={{ color: "#fff", fontSize: 18 }}
        //                 /> : null
        //             }
        //         </div>
        //         <Menu
        //             mode="inline"
        //             selectedKeys={[getSelectedKey()]}
        //             onClick={handleMenuClick}
        //             style={{
        //                 backgroundColor: '#0a2a52',
        //                 color: '#fff',
        //                 borderRight: 0,
        //             }}
        //             theme="dark"
        //             className='bankerSiderBarUl'
        //         >
        //             {menuItems.map(({ key, icon, label }) => (
        //                 <Menu.Item
        //                     key={key}
        //                     icon={icon}
        //                     style={{
        //                         fontWeight: '400',
        //                         fontSize: '14px',
        //                         padding: '12px 22px',
        //                     }}
        //                 >
        //                     {label}
        //                 </Menu.Item>
        //             ))}
        //         </Menu>
        //     </div>
        // </Sider>;
    }


    const renderMenu = () => {
        return (
            <>
                {screens.md ? (
                    <>
                        <Menu
                            mode="horizontal"
                            selectedKeys={[getSelectedKey()]}
                            onClick={handleMenuClick}
                            style={{ flex: 1, minWidth: 0 }}
                        >
                            {menuItems.map(({ key, icon, label }) => (
                                <Menu.Item
                                    key={key}
                                // icon={icon}
                                >
                                    {label}
                                </Menu.Item>
                            ))}
                        </Menu>

                        <div className="user-dropdown-trigger">
                            <SearchOutlined className="user-icon" />
                        </div>

                        <div className="user-dropdown-trigger">
                            <BellOutlined className="user-icon" />
                        </div>

                        {!(localStorage.getItem("IsFirmAdminFlag") === "true") && (
                            <Dropdown
                                overlay={combinedMenu}
                                trigger={['click']}
                                placement="bottomRight"
                                className="headerMenuUserAndLogOut"
                            >
                                <div className="user-dropdown-trigger">
                                    <UserOutlined className="user-icon" />

                                    <span className="user-role-text">
                                        {isConsumerLogin
                                            ? "Investor"
                                            : isAdministratorLogin
                                                ? "Administrator"
                                                : isCapitalProviderLogin
                                                    ? "Capital Provider"
                                                    : ""}
                                    </span>

                                    <DownOutlined className="dropdown-arrow" />
                                </div>
                            </Dropdown>
                        )}

                    </>
                ) : (
                    <div className="side-bar-component__mobile-container">
                        <Avatar
                            icon={<MenuOutlined />}
                            className="side-bar-component__avatar"
                            onClick={() => setDrawerVisible(true)}
                        />

                        {!(localStorage.getItem("IsFirmAdminFlag") == "true") && (
                            <Dropdown overlay={profileMenu} trigger={['hover']}>
                                <Avatar
                                    icon={<UserOutlined />}
                                    className="side-bar-component__avatar"
                                />
                            </Dropdown>
                        )}

                        <Dropdown overlay={userMenu} trigger={['hover']} placement="bottomRight">
                            <Avatar
                                icon={<LogoutOutlined style={{ transform: 'rotate(-90deg)' }} />}
                                className="side-bar-component__avatar"
                            />
                        </Dropdown>
                    </div>
                )}
            </>
        )
    }



    return (
        <Spin spinning={loading}>
            <Layout>
                <Header className="side-bar-component__header">
                    <img
                        src={"/websiteLogo.png"}
                        alt={"Logo"}
                        className="side-bar-component__logo-img"
                    />
                    {renderMenu()}
                </Header>

                <Drawer
                    placement="left"
                    closable={false}
                    onClose={() => setDrawerVisible(false)}
                    open={drawerVisible}
                    bodyStyle={{ padding: 0 }}
                    width={260}
                    className="drawer-container"
                >
                    <div className="drawer-header">
                        <img
                            src={"/websiteLogo.png"}
                            alt={"Logo"}
                            className="drawer-header__logo"
                        />
                        <CloseOutlined
                            onClick={() => setDrawerVisible(false)}
                            className="drawer-header__close-icon"
                        />
                    </div>
                    <Menu
                        mode="inline"
                        selectedKeys={[getSelectedKey()]}
                        onClick={(e) => {
                            handleMenuClick(e);
                            setDrawerVisible(false);
                        }}
                        className="drawer-menu"
                    >
                        {menuItems.map(({ key, icon, label }) => (
                            <Menu.Item
                                key={key}
                                icon={icon}
                            >
                                {label}
                            </Menu.Item>
                        ))}
                    </Menu>
                </Drawer>

                {/* Main Page Content */}
                <Content
                    // style={{
                    //   margin: '24px 24px',
                    //   padding: 24,
                    //   background: '#f5f7fa',
                    //   minHeight: 'calc(100vh - 64px)',
                    // }}
                    style={{
                        minHeight: 'calc(100vh - 75px)',
                        overflow: 'visible',
                        padding: "20px 20px",
                        background: '#0F0F0F',
                    }}

                >
                    {children}
                </Content>
            </Layout>
        </Spin>
    );
};

export default withRouter(SidebarLayoutConsumer);